import "./Mediation.module.css";
import KurumsalKimlikBasligi from "@/reusable_sections/Header";
import DisputeResolutionCenter from "./sections/DisputeResolutionCenter";
import ArabuluculukAlanlari from "./sections/ArabuluculukAlanlari";
import ArabuluculukSureciHakkinda from "./sections/ArabuluculukSureciHakkinda";
import KurumsalAltBilgi from "@/reusable_sections/Footer";
export default function MediationPage() {
  return <div>
      <KurumsalKimlikBasligi />
      <DisputeResolutionCenter />
      <ArabuluculukAlanlari />
      <ArabuluculukSureciHakkinda />
      <KurumsalAltBilgi />
    </div>;
}